import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/i18n';

const NoAccountNeeded = () => {
  const { t, language } = useLanguage();
  const boothPath = language === 'en' ? '/photobooth' : `/${language}/photobooth`;

  return (
    <main className="no-account-container">
      <section className="no-account-card" aria-labelledby="no-account-title">
        <h2 id="no-account-title">{t('noAccountTitle')}</h2>
        <p>{t('noAccountDescription')}</p>
        <Link className="no-account-cta" to={boothPath}>{t('homeStartFree')}</Link>
      </section>
    </main>
  );
};

export default NoAccountNeeded;
